import * as api from '@utils/api'
import { RoleList } from '@types'

export const getRoleList = async (): Promise<RoleList> => {
  const response = await api.GET('/p4/roles')

  return response.data
}
